// @ts-nocheck
import { getCookie } from "@insite/client-framework/Common/Cookies";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
// import { MainNavigationStyles, MappedLink } from "@insite/content-library/Widgets/Header/MainNavigation"; // Starter Custom Code
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
// import ChevronDown from "@insite/mobius/Icons/ChevronDown"; // Starter Custom Code
import Link, { StyledIcon } from "@insite/mobius/Link";
// import Menu from "@insite/mobius/Menu"; // Starter Custom Code
import Popover from "@insite/mobius/Popover";
import * as React from "react";
import { ThemeProps, withTheme } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import Menu from "@store/MobiusOverrides/Menu/Menu";
import { MainNavigationStyles, MappedLink } from "@store/Overrides/Widgets/Header/MainNavigation";
import { connect } from "react-redux";
import uniqueId from "lodash/uniqueId";

/* Store Custom Code - Start */
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { css } from "styled-components";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import getColor from "@insite/mobius/utilities/getColor";
import { GridItemStyle } from "@insite/mobius/GridItem";
/* Store Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    currentLocation: getLocation(state),
});

const getFilteredChildren = (child: MappedLink, displayChangeCustomerLink: boolean) => {
    return (
        child.children?.filter(children => {
            if (children.excludeFromNavigation) {
                return false;
            }
            if (children.type === "ChangeCustomerPage" && !displayChangeCustomerLink) {
                return false;
            }
            if (children.type === "VmiUsersPage") {
                const currentMode = getCookie(NavigationModeCookieName);
                if (!currentMode || currentMode === "Storefront") {
                    return false;
                }
            }
            return true;
        }) || []
    );
};
/* Starter Custom Code - End */

interface OwnProps {
    link: MappedLink;
    index: number;
    styles: MainNavigationStyles;
    container: React.RefObject<HTMLElement | null>;
    isOpen: boolean;
    displayChangeCustomerLink: boolean;
}

type Props = ThemeProps<BaseTheme> & OwnProps & ReturnType<typeof mapStateToProps> /* Starter Custom Code */;

/* Starter Custom Code - Start */
type State = {
    currentTab?: string;
    isCurrentTabOpen?: boolean;
    uid?: string;
};
/* Starter Custom Code - End */

class MainNavigationItem extends React.Component<Props, State /* Starter Custom Code */> {
    /* Starter Custom Code - Start */
    firstTabKey: string | undefined = undefined;

    constructor(props: Props) {
        super(props);

        this.state = {
            currentTab: undefined,
            isCurrentTabOpen: false,
            uid: uniqueId(),
        };
    }

    popoverWrapper = React.createRef<HTMLDivElement>();
    /* Starter Custom Code - End */

    element = React.createRef<HTMLElement>();
    popover = React.createRef<any>();

    componentDidUpdate(prevProps: Readonly<Props>) {
        /* Starter Custom Code - Start */
        if (!this.firstTabKey) {
            this.initNav();
        }
        /* Starter Custom Code - End */
        if (this.props.isOpen && !prevProps.isOpen) {
            this.openPopover();
        } else if (!this.props.isOpen && prevProps.isOpen) {
            this.closePopover();
        }
    }

    closePopover = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    openPopover = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    /* Starter Custom Code - Start */
    initNav = () => {
        const firstChild = this.props.link?.children?.filter(child => !child.excludeFromNavigation)[0];
        const tabKey = firstChild?.title;

        if (tabKey) {
            this.firstTabKey = tabKey;
            this.setState({ currentTab: tabKey, isCurrentTabOpen: true });
        }
    };

    changeTab = (tabKey: string) => {
        if (tabKey === this.state.currentTab) {
            this.setState({ currentTab: tabKey, isCurrentTabOpen: !this.state.isCurrentTabOpen });
        } else {
            this.setState({ currentTab: tabKey, isCurrentTabOpen: true });
        }
    };

    handleMouseLeave = (event: React.MouseEvent) => {
        const relatedTarget = event.relatedTarget as Node | null;
        if (this.popoverWrapper.current?.contains(relatedTarget)) {
            return;
        }
        this.closePopover();
    };
    /* Starter Custom Code - End */

    render() {
        const {
            styles,
            link,
            index,
            isOpen,
            theme: {
                breakpoints: { maxWidths },
            },
        } = this.props;
        const downIcon = <StyledIcon src={ChevronDown} {...styles.menuItemIcon} />;
        const hasChildren = link.children && link.children.filter(child => !child.excludeFromNavigation).length > 0;
        const isCascading =
            hasChildren && (link.childrenType === "CascadingMenu" || link.childrenType === "CustomLinkList");
        /* Starter Custom Code - Start */
        const isMega = hasChildren && link.childrenType === "MegaMenu" && !link.isMegaMenuWithTabs;
        const isMegaWithTabs = hasChildren && link.childrenType === "MegaMenu" && link.isMegaMenuWithTabs;
        const maxChild = link.maxChild ?? 99;
        const maxChildren = link.maxChildren ?? 3;
        const maxGrandChildren = link.maxGrandChildren ?? 3;
        const { currentTab, isCurrentTabOpen } = this.state;
        const useOnHover = link.useOnHover;
        /* Starter Custom Code - End */

        /* Store Custom Code - Start */
        const megaMenuGridContainerStyles = mergeProps<MainNavigationStyles["megaMenuGridContainer"]>(
            styles.megaMenuGridContainer,
            {
                css: css`
                    ${link.numberOfColumns && link.numberOfColumns > 1
                        ? css`
                              ${GridItemStyle}:not(:nth-child(${link.numberOfColumns}n), [data-test-selector="viewAllWrapper"]) {
                                  border-right: ${pxToRem(1)} solid ${getColor("menu.mainNavigation.separator")};
                              }
                          `
                        : ""}
                `,
            },
        );
        /* Store Custom Code - End */

        let menuLink = (
            <Link
                className="menu-item"
                typographyProps={styles.menuItemTypography}
                color={styles.menuItemTypography?.color}
                {...styles.menuItem}
                href={isCascading && !useOnHover ? undefined : link.url} // Starter Custom Code
                target={link.url ? (link.openInNewWindow ? "_blank" : "_self") : undefined} // Starter Custom Code
                aria-haspopup={isCascading} // Starter Custom Code
                aria-expanded={isOpen} // Starter Custom Code
            >
                {link.title}
                {isCascading && downIcon}
            </Link>
        );
        if (isMega || link.url === "" || isMegaWithTabs /* Starter Custom Code */) {
            menuLink = (
                <Link
                    className="menu-item"
                    typographyProps={styles.menuItemTypography}
                    onClick={() => {}} // Starter Custom Code - Ensure the link will always be a "button"
                    onMouseEnter={useOnHover ? this.openPopover : undefined} // Starter Custom Code
                    onMouseLeave={useOnHover ? this.handleMouseLeave : undefined} // Starter Custom Code
                    onFocus={useOnHover ? this.openPopover : undefined} // Starter Custom Code
                    /* Starter Removed - color */
                    {...styles.menuItem}
                >
                    {link.title}
                    {(isCascading || isMega || isMegaWithTabs) /* Starter Custom Code */ && downIcon}
                </Link>
            );
        }

        let menuItem = menuLink;

        if (isCascading && link.children) {
            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            /* Starter Custom Code - Start */
            const menuItemsArray =
                link.url && !useOnHover
                    ? [
                          {
                              ...link,
                              title: `${translate("View")} ${link.title}`,
                              children: undefined,
                              isViewAll: true,
                          },
                          ...link.children,
                      ]
                    : link.children;
            /* Starter Custom Code - End */

            menuItem = (
                <Menu
                    className="cascading-menu"
                    data-test-selector={`mainNavigationItem_${index}`}
                    isOpen={isOpen || undefined}
                    descriptionId={`${link.title}_${this.state.uid}`}
                    menuItems={menuItemsArray} // Starter Custom Code
                    menuTrigger={menuLink}
                    displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                    useOnHover={useOnHover} // Starter Custom Code
                    width={250} // Starter Custom Code
                    {...menuProps}
                    {...styles.cascadingMenu}
                />
            );
        }

        if (isMega) {
            menuItem = (
                <StyledWrapper ref={this.popoverWrapper} /* Starter Custom Code */>
                    <Popover
                        className="mega-menu"
                        zIndexKey="menu"
                        {...styles.megaMenu}
                        contentBodyProps={{
                            ...styles.megaMenu?.contentBodyProps,
                            /* Starter Removed - _width */
                            as: "div",
                        }}
                        controlsId={`${index}_${link.title}`}
                        ref={this.popover}
                        positionFunction={(element: React.RefObject<HTMLUListElement | null>) => {
                            return { position: "fixed" }; // Starter Custom Code
                        }}
                        popoverTrigger={menuLink}
                        insideRefs={[this.element]}
                        onMouseLeave={useOnHover ? this.closePopover : undefined} // Starter Custom Code
                    >
                        <StyledWrapper {...styles.megaMenuContentWrapper} /* Starter Custom Code */>
                            <GridContainer
                                className="mega-menu-grid-container"
                                data-test-selector={`mainNavigationItem_${index}`}
                                {...megaMenuGridContainerStyles} /* Store Custom Code */
                                offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                            >
                                {link
                                    .children!.filter(child => !child.excludeFromNavigation)
                                    .slice(0, maxChild) // Starter Custom Code
                                    .map((child, index) => (
                                        <GridItem
                                            className="mega-menu-grid-item"
                                            width={(12 / link.numberOfColumns!) as GridWidths}
                                            key={index}
                                            {...styles.megaMenuGridItem}
                                            // Starter Removed - as
                                        >
                                            <Link
                                                className="mega-menu-heading-link"
                                                {...styles.megaMenuHeading}
                                                href={child.url}
                                                onClick={this.closePopover}
                                            >
                                                {child.title}
                                            </Link>
                                            {child.children && child.children.length > 0 /* Starter Custom Code */ && (
                                                <StyledWrapper /* Starter Custom Code */
                                                    as="ul"
                                                    {...styles.megaMenuChildren}
                                                    data-test-selector={`linksFor_${child.title}`}
                                                >
                                                    {getFilteredChildren(
                                                        child,
                                                        this.props.displayChangeCustomerLink,
                                                    ) /* Starter Custom Code */
                                                        .slice(0, maxChildren + 1) // Starter Custom Code - Voluntarily keep one more item to show the see all button
                                                        .map((grandChild, index) => {
                                                            /* Starter Custom Code - Start */
                                                            return index >= maxChildren ? (
                                                                <li key={index}>
                                                                    <Link
                                                                        className="mega-menu-more-link"
                                                                        {...styles.megaMenuSeeMoreLink}
                                                                        onClick={this.closePopover}
                                                                        href={child.url}
                                                                    >
                                                                        {translate(
                                                                            "See all ({0})",
                                                                            child.children?.length.toString() || "",
                                                                        )}
                                                                    </Link>
                                                                </li>
                                                            ) : (
                                                                <li key={index}>
                                                                    <Link
                                                                        className="mega-menu-link"
                                                                        {...styles.megaMenuLink}
                                                                        onClick={this.closePopover}
                                                                        href={grandChild.url}
                                                                        data-test-selector={grandChild.title}
                                                                    >
                                                                        {grandChild.title}
                                                                    </Link>
                                                                </li>
                                                            );
                                                            /* Starter Custom Code - End */
                                                        })}
                                                </StyledWrapper>
                                            )}
                                        </GridItem>
                                    ))}
                                {/* Starter Custom Code - Start */}
                                {this.props.link.url && (
                                    <GridItem
                                        width={12}
                                        as="li"
                                        data-test-selector="viewAllWrapper" /* Store Custom Code */
                                    >
                                        <Link
                                            {...styles.megaMenuViewAllLink}
                                            onClick={this.closePopover}
                                            href={this.props.link.url}
                                        >
                                            {translate("View All")} {this.props.link.title}
                                        </Link>
                                    </GridItem>
                                )}
                                {/* Starter Custom Code - End */}
                            </GridContainer>
                        </StyledWrapper>
                    </Popover>
                </StyledWrapper>
            );
        }

        /* Starter Custom Code - Start */
        if (isMegaWithTabs) {
            const child = link.children!.filter(child => !child.excludeFromNavigation);
            menuItem = (
                <StyledWrapper ref={this.popoverWrapper} /* Starter Custom Code */>
                    <Popover
                        className="mega-menu"
                        zIndexKey="menu"
                        {...styles.megaMenu}
                        contentBodyProps={{
                            ...styles.megaMenuWithTabs?.contentBodyProps,
                            as: "div",
                        }}
                        controlsId={`${index}_${link.title}`}
                        ref={this.popover}
                        positionFunction={() => ({ position: "fixed" })}
                        popoverTrigger={menuLink}
                        insideRefs={[this.element]}
                        onOpen={this.initNav}
                        onMouseLeave={useOnHover ? this.closePopover : undefined} // Starter Custom Code
                    >
                        <StyledWrapper {...styles.megaMenuWithTabsContentWrapper}>
                            <StyledWrapper {...styles.megaMenuWithTabsWrapper} as="ul">
                                {child.slice(0, maxChild).map((child, index) => {
                                    const tabKey = child.title;
                                    const id = child.title.replace(/\W/g, "-").toLowerCase();
                                    const hasChildren = Boolean(child.children?.some(x => !x.excludeFromNavigation));
                                    return (
                                        <StyledWrapper as="li" key={child.title} {...styles.megaMenuWithTabsMainChild}>
                                            <Link
                                                {...(tabKey === currentTab || hasChildren
                                                    ? styles.megaMenuWithTabsMainChildWithSubmenuLink
                                                    : styles.megaMenuWithTabsMainChildLink)}
                                                href={!hasChildren ? child.url : undefined}
                                                onClick={
                                                    tabKey === currentTab || hasChildren
                                                        ? () => this.changeTab(tabKey)
                                                        : this.closePopover
                                                }
                                                onMouseOver={
                                                    useOnHover && hasChildren ? () => this.changeTab(tabKey) : undefined
                                                } // Starter Custom Code
                                                aria-haspopup={tabKey === currentTab || hasChildren}
                                                aria-controls={id}
                                                aria-expanded={tabKey === currentTab}
                                                aria-current={
                                                    this.props.currentLocation.pathname === child.url
                                                        ? "page"
                                                        : undefined
                                                }
                                            >
                                                {child.title}
                                            </Link>

                                            {tabKey === currentTab && (
                                                <GridContainer
                                                    id={id}
                                                    role="menu"
                                                    className="mega-menu-grid-container"
                                                    data-test-selector={`mainNavigationItem_${index}`}
                                                    {...styles.megaMenuWithTabsGridContainer}
                                                    offsetProps={{
                                                        ...styles.megaMenuWithTabsGridContainer?.offsetProps,
                                                        as: "ul",
                                                    }}
                                                >
                                                    {getFilteredChildren(child, this.props.displayChangeCustomerLink)
                                                        .slice(0, maxChildren)
                                                        .map((children, index) => (
                                                            <GridItem
                                                                className="mega-menu-grid-item"
                                                                width={(12 / link.numberOfColumns!) as GridWidths}
                                                                key={`${children.url}-${index}`}
                                                                {...styles.megaMenuGridItem}
                                                            >
                                                                <Link
                                                                    className="mega-menu-heading-link"
                                                                    {...styles.megaMenuHeading}
                                                                    href={children.url}
                                                                    onClick={this.closePopover}
                                                                    tabIndex={isCurrentTabOpen ? 0 : -1}
                                                                    aria-current={
                                                                        this.props.currentLocation.pathname ===
                                                                        children.url
                                                                            ? "page"
                                                                            : undefined
                                                                    }
                                                                >
                                                                    {children.title}
                                                                </Link>
                                                                {children.children && children.children.length > 0 && (
                                                                    <StyledWrapper
                                                                        as="ul"
                                                                        {...styles.megaMenuChildren}
                                                                        data-test-selector={`linksFor_${child.title}`}
                                                                    >
                                                                        {getFilteredChildren(
                                                                            children,
                                                                            this.props.displayChangeCustomerLink,
                                                                        )
                                                                            .slice(0, maxGrandChildren + 1)
                                                                            .map((grandChildren, index) => {
                                                                                return index >= maxGrandChildren ? (
                                                                                    <li key={grandChildren.title}>
                                                                                        <Link
                                                                                            className="mega-menu-more-link"
                                                                                            {...styles.megaMenuSeeMoreLink}
                                                                                            onClick={this.closePopover}
                                                                                            href={children.url}
                                                                                            tabIndex={
                                                                                                isCurrentTabOpen
                                                                                                    ? 0
                                                                                                    : -1
                                                                                            }
                                                                                            aria-current={
                                                                                                this.props
                                                                                                    .currentLocation
                                                                                                    .pathname ===
                                                                                                children.url
                                                                                                    ? "page"
                                                                                                    : undefined
                                                                                            }
                                                                                        >
                                                                                            {translate(
                                                                                                "See all ({0})",
                                                                                                children.children?.length.toString() ||
                                                                                                    "",
                                                                                            )}
                                                                                        </Link>
                                                                                    </li>
                                                                                ) : (
                                                                                    <li key={grandChildren.title}>
                                                                                        <Link
                                                                                            className="mega-menu-link"
                                                                                            {...styles.megaMenuLink}
                                                                                            onClick={this.closePopover}
                                                                                            href={grandChildren.url}
                                                                                            data-test-selector={
                                                                                                grandChildren.title
                                                                                            }
                                                                                            tabIndex={
                                                                                                isCurrentTabOpen
                                                                                                    ? 0
                                                                                                    : -1
                                                                                            }
                                                                                            aria-current={
                                                                                                this.props
                                                                                                    .currentLocation
                                                                                                    .pathname ===
                                                                                                grandChildren.url
                                                                                                    ? "page"
                                                                                                    : undefined
                                                                                            }
                                                                                        >
                                                                                            {grandChildren.title}
                                                                                        </Link>
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                    </StyledWrapper>
                                                                )}
                                                            </GridItem>
                                                        ))}
                                                    <GridItem width={12} {...styles.megaMenuGridItem}>
                                                        <Link
                                                            {...styles.megaMenuViewAllLink}
                                                            onClick={this.closePopover}
                                                            href={child.url}
                                                            tabIndex={isCurrentTabOpen ? 0 : -1}
                                                            aria-current={
                                                                this.props.currentLocation.pathname === child.url
                                                                    ? "page"
                                                                    : undefined
                                                            }
                                                        >
                                                            {translate("See all {0}", child.title || "")}
                                                        </Link>
                                                    </GridItem>
                                                </GridContainer>
                                            )}
                                        </StyledWrapper>
                                    );
                                })}
                                {this.props.link.url && maxChild < child.length && (
                                    <StyledWrapper as="li" {...styles.megaMenuWithTabsViewAllWrapper}>
                                        <Link
                                            {...styles.megaMenuWithTabsViewAllLink}
                                            onClick={this.closePopover}
                                            href={this.props.link.url}
                                        >
                                            {translate("View All")} {this.props.link.title}
                                        </Link>
                                    </StyledWrapper>
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    </Popover>
                </StyledWrapper>
            );
        }
        /* Starter Custom Code - End */

        return menuItem;
    }
}

export default connect(mapStateToProps)(withTheme(MainNavigationItem)) /* Starter Custom Code */;
